import { render, staticRenderFns } from "./MenuBottomEsp.vue?vue&type=template&id=248fe74c&scoped=true&"
import script from "./MenuBottomEsp.vue?vue&type=script&lang=js&"
export * from "./MenuBottomEsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fe74c",
  null
  
)

export default component.exports